
// The font of the app's own screens (the picpopstudio.com brand font). The fonts a user can pick for the
// text on their AR experience are the other exports below and the Montserrat entry in FontFamilyTypes.
export const FontFamily = {
    regular:"PlusJakartaSans-Regular",
    medium:"PlusJakartaSans-Medium",
    semiBold:"PlusJakartaSans-SemiBold",
    bold:"PlusJakartaSans-Bold",
    light:"PlusJakartaSans-Regular",
}

export const DMSansFF = {
    bold:"DMSans-Bold",
    regular:"DMSans-Regular",
    italic:"DMSans-Italic",
}

export const OpenSansFF = {
    regular:"OpenSans-Regular",
    bold:"OpenSans-Bold",
    italic:"OpenSans-Italic",
}

export const FunnelSans = {
    regular:"FunnelSans-Regular",
    bold:"FunnelSans-Bold",
    italic:"FunnelSans-Italic",
}

export const IBMPlexSerifFF = {
    bold:"IBMPlexSerif-Bold",
    regular:"IBMPlexSerif-Regular",
    italic:"IBMPlexSerif-Italic",
}

export const PoppinsFF = {
    bold:"Poppins-Bold",
    regular:"Poppins-Regular",
    italic:"Poppins-Italic",
}

export const RobotoFF = {
    bold:"Roboto-Bold",
    regular:"Roboto-Regular",
    italic:"Roboto-Italic",
}

export const SpectralFF = {
    bold:"Spectral-Bold",
    regular:"Spectral-Regular",
    italic:"Spectral-Italic",
}

export const RubikFF = {
    regular:"Rubik-Regular",
    bold:"Rubik-Bold",
    italic:"Rubik-Italic",
}

export const TinosFF = {
    regular:"Tinos-Regular",
    bold:"Tinos-Bold",
    italic:"Tinos-Italic",
}
